import {
  getIsBingeDrinker,
  getIsDangerousToHealth
} from "@dcc/score/dangerousLevels";
import { RiskLevel } from "@dcc/types/riskLevel";
import { GetterTree } from "vuex";

import { IRootGetters, IRootState } from "../../types";
import { ScoreState } from "../types";
import { GetterNames } from "./names";
import { IScoreGetters } from "./types";

export const getters: GetterTree<ScoreState, IRootState> = {
  [GetterNames.ISDANGEROUSTOHEALTH](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): boolean {
    const totalWeeklyDrinks = getters[GetterNames.TOTALWEEKLYDRINKS];
    const gender = rootGetters["profile/gender"];
    return gender !== undefined
      ? getIsDangerousToHealth(totalWeeklyDrinks, gender)
      : false;
  },
  [GetterNames.ISBINGEDRINKER](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): boolean {
    const highestUnitsPerDay = getters[GetterNames.HIGHESTUNITSPERDAY];
    const gender = rootGetters["profile/gender"];
    return gender !== undefined
      ? getIsBingeDrinker(highestUnitsPerDay, gender)
      : false;
  },
  [GetterNames.ISLOWRISKBINGEDRINKER](
    state: ScoreState,
    getters: IScoreGetters,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): boolean {
    return getters["isBingeDrinker"] && getters["riskLevel"] == RiskLevel.Low;
  }
};
